class Coordinate3D {
    constructor(x, y, z) {
        this.x = x !== null && x !== void 0 ? x : 0;
        this.y = y !== null && y !== void 0 ? y : 0;
        this.z = z !== null && z !== void 0 ? z : 0;
    }
    toString() {
        return this.x + " " + this.y + " " + this.z;
    }
    translate(dx, dy, dz) {
        return new Coordinate3D(this.x + dx, this.y + dy, this.z + dz);
    }
    add(other) {
        return new Coordinate3D(this.x + other.x, this.y + other.y, this.z + other.z);
    }
    subtract(other) {
        return new Coordinate3D(this.x - other.x, this.y - other.y, this.z - other.z);
    }
    multiply(mult) {
        return new Coordinate3D(this.x * mult, this.y * mult, this.z * mult);
    }
    dot(other) {
        return new Coordinate3D(this.x * other.x + this.y * other.y + this.z + other.z);
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    normalize() {
        let length = this.length();
        return new Coordinate3D(this.x / length, this.y / length, this.z / length);
    }
}
export default Coordinate3D;
